import { useState, useEffect } from 'react'
import moment from 'moment'
import {
  Navbar,
  Container,
  Row,
  Carousel,
  Button,
  Col,
  Card,
  Modal,
  OverlayTrigger,
  Tooltip,
} from 'react-bootstrap'
import { BsChevronLeft, BsChevronRight } from 'react-icons/bs'
import { Select, Space } from 'antd'
import { toAbsoluteUrl } from '../../../../../_metronic/helpers'
import { MenuItem } from '../../../../../_metronic/layout/components/header/MenuItem'

import MyLineChart2 from '../.././MyLineChart2'
import WeekSelect from '../.././WeekSelect'
import clsx from 'clsx'
import { checkIsActive } from '../../../../../_metronic/helpers'
import { useLocation, useNavigate } from 'react-router'
import BluedotNewsfeedDropdown from '../../../home/components/BluedotNewsfeedDropdown'
import EuropeMaps from '../../EuropeMaps'
import axios from 'axios'
import { useSelectedWeek } from '../../../../contexts/SelectedWeekContext'
interface ItemType {
  id: number
  title: string
  campaigns: number
  path: string
  bgColor: string
}
//\_metronic\partials\layout\header-menus\HeaderUserMenuPublic.tsx
const NavSlider = () => {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const items: ItemType[] = [
    {
      id: 1,
      title: 'Respiratory Syndromes in social media',
      campaigns: 4,
      path: 'respiratory-sydroms-in-social-media',
      bgColor: '#6441A5',
    },
    {
      id: 2,
      title: 'Doctor visits for Respiratory Syndromes',
      campaigns: 4,
      path: 'ambulatory-care_doctor-visits',
      bgColor: '#6441A5',
    },

    {
      id: 3,
      title: 'Emergency room visits for Respiratory Syndromes',
      campaigns: 4,
      path: 'hospital-emergency-room-visits',
      bgColor: '#6441A5',
    },
    {
      id: 4,
      title: 'Hospital admissions for Respiratory Syndromes',
      campaigns: 4,
      path: 'hospital-adminssions',
      bgColor: '#6441A5',
    },

    {
      id: 5,
      title: 'ICU admissions for Respiratory Syndromes',
      campaigns: 4,
      path: 'icu-adminssions',
      bgColor: '#6441A5',
    },
    {
      id: 6,
      title: 'Deaths for Respiratory Syndromes',
      campaigns: 4,
      path: 'hospital-deaths-for-respiratory-synd',
      bgColor: '#6441A5',
    },

    {
      id: 7,
      title: 'Influenza positivity rate',
      campaigns: 4,
      path: 'virology-influenza',
      bgColor: '#6441A5',
    },
    {
      id: 8,
      title: 'Covid-19 positivity rate and variants',
      campaigns: 4,
      path: 'virology-covid',
      bgColor: '#6441A5',
    },
    { id: 9, title: 'RSV positivity rate', campaigns: 4, path: 'virology-rsv', bgColor: '#6441A5' },
    {
      id: 10,
      title: 'Viral Load in wastewater - Covid-19',
      campaigns: 4,
      path: 'virology-waste-water',
      bgColor: '#6441A5',
    },

    // Add more items as needed
  ]
  const { pathname } = useLocation()

  const [itemsPerSlide, setItemsPerSlide] = useState(6)
  const [totalItems, setTotalItems] = useState<ItemType[][]>([]) // Specify the type here
  const [activeIndex, setActiveIndex] = useState(0)
  const [hoveredItem, setHoveredItem] = useState<number | null>(null) // Specify the type here

  const handleHover = (itemId: number, isHovered: boolean) => {
    setHoveredItem(isHovered ? itemId : null)
  }
  function getItemIdByPath(items: ItemType[], pathToCheck: string): number {
    const foundItem = items.find((item) => '/fr/' + item.path === pathToCheck)

    return foundItem ? foundItem.id : 0
  }

  useEffect(() => {
    const updateItemsPerSlide = () => {
      const screenWidth = window.innerWidth
      const itemId = getItemIdByPath(items, pathname)

      if (screenWidth <= 650) {
        if (itemId <= 2) {
          setActiveIndex(0)
        } else if (itemId === 3 || itemId === 4) {
          setActiveIndex(1)
        } else if (itemId === 5 || itemId === 6) {
          setActiveIndex(2)
        } else if (itemId === 7 || itemId === 8) {
          setActiveIndex(3)
        } else {
          // activeIndex = 4

          setActiveIndex(4)
        }
        setItemsPerSlide(2)
      } else if (screenWidth <= 980) {
        if (itemId / 4 <= 1) {
          setActiveIndex(0)
        } else if (itemId / 4 <= 2) {
          setActiveIndex(1)
        } else {
          setActiveIndex(2)
        }
        setItemsPerSlide(4)
      } else {
        if (itemId < 7) {
          setActiveIndex(0)
        } else {
          setActiveIndex(1)
        }
        setItemsPerSlide(6)
      }
    }

    updateItemsPerSlide()

    window.addEventListener('resize', updateItemsPerSlide)

    return () => {
      window.removeEventListener('resize', updateItemsPerSlide)
    }
  }, [])

  useEffect(() => {
    setTotalItems(
      [...Array(Math.ceil(items.length / itemsPerSlide))].map((_, i) =>
        items.slice(i * itemsPerSlide, (i + 1) * itemsPerSlide)
      )
    )
  }, [items, itemsPerSlide])

  const handlePrevClick = () => {
    setActiveIndex((prevIndex) => Math.max(0, prevIndex - 1))
  }

  const handleNextClick = () => {
    setActiveIndex((prevIndex) => Math.min(totalItems.length - 1, prevIndex + 1))
  }

  return (
    <div className='p-0 app-header-slider d-flex justify-content-center align-items-center flex-stack'>
      {/* Slider Navigation Buttons */}
      <Button
        className='btn btn-icon btn-color-red btn-active-color-primary ms-xxl-n18'
        variant='light'
        disabled={activeIndex === 0}
        onClick={handlePrevClick}
      >
        <BsChevronLeft size={20} />
      </Button>
      {/* Header Slider */}
      <Carousel
        className=' d-flex justify-content-center align-items-center w-100'
        interval={null}
        wrap={false}
        controls={false}
        activeIndex={activeIndex}
        indicators={false}
        onSelect={(index) => setActiveIndex(index)}
      >
        {totalItems.map((slideItems, slideIndex) => (
          <Carousel.Item key={slideIndex}>
            <div
              className='m-3  d-flex justify-content-center align-items-center'
              style={{ gap: 20 }}
            >
              {slideItems.map((item) => (
                <MenuItem title={item.title} to={item.path} />
              ))}
            </div>
          </Carousel.Item>
        ))}
      </Carousel>
      {/* Slider Navigation Buttons */}
      <Button
        className='btn btn-icon btn-color-red btn-active-color-primary me-xxl-n18'
        variant='light'
        disabled={activeIndex === totalItems.length - 1}
        onClick={handleNextClick}
      >
        <BsChevronRight size={20} />
      </Button>
    </div>
  )
}
const EuropModal = ({ showModal, handleClose }) => {
  return (
    <Modal size='lg' centered show={showModal} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>Europe</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <EuropeMaps />
      </Modal.Body>
      <Modal.Footer>
        <Button variant='secondary' onClick={handleClose}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
function FixedNavbar() {
  const [showModal, setShowModal] = useState(false)

  const handleShow = () => setShowModal(true)
  const handleClose = () => setShowModal(false)
  const { Option } = Select
  const handleChange = (value) => {
    // Handle language change logic here
  }
  return (
    <Navbar fixed='top' className=' bg-gray-300 '>
      <Container className='px-0'>
        <Navbar.Brand style={{ marginLeft: '-2.2%' }} className='text-primary fw-bold ' href='/fr'>
          AIOLOS-dashboard.com
        </Navbar.Brand>
        <Navbar.Toggle aria-controls='navbarSupportedContent' />

        <div style={{ marginRight: '-2.2%' }}>
          <Space className='mx-10'>
            <div>
              {/* <Button variant='primary' onClick={handleShow}>
                <i className='fa-solid fa-earth-europe'></i>Map
              </Button> */}

              <EuropModal showModal={showModal} handleClose={handleClose} />
            </div>
            <div>
              <BluedotNewsfeedDropdown />
            </div>

            <Select
              variant='borderless'
              size={'large'}
              defaultValue='en'
              style={{ width: 100 }}
              onChange={handleChange}
            >
              <Option value='en'>English</Option>
              <Option value='fr'>French</Option>
              <Option value='ge'>Deutsch</Option>
              {/* Add more language options as needed */}
            </Select>
          </Space>

          <img
            style={{ width: '80px', marginRight: '-6%' }}
            alt='logo'
            src={toAbsoluteUrl('/media/logos/ailos-logo.png')}
          />
        </div>
      </Container>
    </Navbar>
  )
}

function ScrollNavbar() {
  return (
    <Navbar fixed='top' className='bg-secondary navbar-dark justify-content-center'>
      <Row className='d-flex '>
        <Col md={12}>
          <FixedNavbar />
        </Col>
        <Col md={12} className='p-4 mt-20'>
          <Container>
            <NavSlider />
          </Container>
        </Col>
      </Row>
    </Navbar>
  )
}
interface WeeklyData {
  week: string | null
}

interface NumberUsersRsAlerts extends WeeklyData {
  dataGraph: number
  weeklyAnomalyScore: string
  tenthPercentileThreshold: string
  fifthPercentileThreshold: string
}

interface DoctorsVisitsRsAlerts extends WeeklyData {
  dataGraph: string
  alertVirus: number
}

interface EmergencyRoomVisitsRsAlerts extends WeeklyData {
  dataGraph: null
  diagnosisCategory: string
  ageClass: string
  alertVirus: number
}

interface HospitalAdmissionsRsAlerts extends WeeklyData {
  dataGraph: string
  diagnosisCategory: string
  ageClass: string
  rssDurationClass: string
  alertVirus: number
}

interface IcuAdmissionsRsDiagnosisAlerts extends WeeklyData {
  dataGraph: string
  diagnosisCategory: string
  geographicalOrigin: string
  alertVirus: number
}

interface RsDiagnosisDeathsAlerts extends WeeklyData {
  dataGraph: string
  diagnosisCategory: string
  alertVirus: number
}

interface InfluenzaPositivityRatesAlerts extends WeeklyData {
  dataGraph: string
  ageClass: string
  alertVirus: number
}

interface Covid19PositivityRatesAlerts extends WeeklyData {
  dataGraph: string
  ageClass: string
  alertVirus: number
}

interface RsvPositivityRatesAlerts extends WeeklyData {
  dataGraph: string
  ageClass: string
  alertVirus: number
}

interface WastewaterViralRatesAlerts extends WeeklyData {
  dataGraph: number
}

interface DataObject {
  [key: string]: WeeklyData[]
}

interface Data {
  numberUsersRsAlerts: NumberUsersRsAlerts[]
  doctorsVisitsRsAlerts: DoctorsVisitsRsAlerts[]
  emergencyRoomVisitsRsAlerts: EmergencyRoomVisitsRsAlerts[]
  hospitalAdmissionsRsAlerts: HospitalAdmissionsRsAlerts[]
  icuAdmissionsRsDiagnosisAlerts: IcuAdmissionsRsDiagnosisAlerts[]
  rsDiagnosisDeathsAlerts: RsDiagnosisDeathsAlerts[]
  influenzaPositivityRatesAlerts: InfluenzaPositivityRatesAlerts[]
  covid19PositivityRatesAlerts: Covid19PositivityRatesAlerts[]
  rsvPositivityRatesAlerts: RsvPositivityRatesAlerts[]
  wastewaterViralRatesAlerts: WastewaterViralRatesAlerts[]
}
interface DataEntry {
  x: string
  y: string | number
  isMissing? : boolean 
}
export function HomeHeader() {
  const [showScrollNavbar, setShowScrollNavbar] = useState(false)
  const { pathname } = useLocation()
  let navigate = useNavigate()
  const { Option } = Select

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.pageYOffset || document.documentElement.scrollTop
      setShowScrollNavbar(scrollPosition > 100)
    }

    window.addEventListener('scroll', handleScroll)

    return () => window.removeEventListener('scroll', handleScroll)
  }, [])
  const [hoveredCard, setHoveredCard] = useState(null)

  const handleMouseEnter = (index) => {
    setHoveredCard(index)
  }

  const handleMouseLeave = () => {
    setHoveredCard(null)
  }
  function roundToDecimal(num: number, decimalPlaces: number): number {
    const multiplier = Math.pow(10, decimalPlaces)
    return Math.round(num * multiplier) / multiplier
  }
  const [dataGraph, setDataGraph] = useState<Data | null>(null)
  const [alertData, setAlertData] = useState<Data | null>(null)

  const { selectedWeek, setSelectedWeek } = useSelectedWeek('2023-W40')
  const [loading, setLoading] = useState(false)
  const API_URL = process.env.REACT_APP_API_URL
  function getAlertedAgeClasses(
    data:
      | EmergencyRoomVisitsRsAlerts[]
      | HospitalAdmissionsRsAlerts[]
      | Covid19PositivityRatesAlerts[]
      | RsvPositivityRatesAlerts[]
      | InfluenzaPositivityRatesAlerts[]

      | null
  ): string[] | null {
    if (!data) {
      return null // Return null if data is undefined
    }

    const alertedAgeClassesSet: Set<string> = new Set()
    const allertAll: string[] = []

    for (const entry of data) {
      if (entry.alertVirus === 1) {
        alertedAgeClassesSet.add(entry.ageClass)
      }
    }

    // Convert the Set back to an array
    return Array.from(alertedAgeClassesSet)
  }
  function getAlert(
    data:
      | EmergencyRoomVisitsRsAlerts[]
      | HospitalAdmissionsRsAlerts[]
      | Covid19PositivityRatesAlerts[]
      | RsvPositivityRatesAlerts[]
      | InfluenzaPositivityRatesAlerts[]
      | null
  ): string[] | null {
    if (!data) {
      return null // Return null if data is undefined
    }

    // const alertedAgeClassesSet: Set<string> = new Set()
    const allertAll: string[] = []

    for (const entry of data) {
      if (entry.alertVirus === 1) {
        allertAll.push(entry.ageClass)
      }
    }

    // Convert the Set back to an array
    return allertAll
  }
  function getAlertVirus(
    data: IcuAdmissionsRsDiagnosisAlerts[] | RsDiagnosisDeathsAlerts[] | null
  ): string[] | null {
    if (!data) {
      return null // Return null if data is undefined
    }

    //  const alertedAgeClassesSet: Set<string> = new Set()
    const allertAll: string[] = []

    for (const entry of data) {
      if (entry.alertVirus === 1) {
        allertAll.push(entry.diagnosisCategory)
      }
    }

    // Convert the Set back to an array
    return allertAll
  }
  function processData(
    dataTabGraph: (
      | NumberUsersRsAlerts
      | DoctorsVisitsRsAlerts
      | EmergencyRoomVisitsRsAlerts
      | HospitalAdmissionsRsAlerts
      | Covid19PositivityRatesAlerts
      | RsvPositivityRatesAlerts
      | IcuAdmissionsRsDiagnosisAlerts
      | InfluenzaPositivityRatesAlerts
      | RsDiagnosisDeathsAlerts
      | WastewaterViralRatesAlerts
    )[],
    selectedWeek: string
  ): DataEntry[] {
    const processedData: DataEntry[] = []
    const weeksToCheck: number[] = [2, 1, 0] // To get the previous weeks in reverse order

    weeksToCheck.forEach((weekOffset, index) => {
      const xValue: string = getPreviousWeek(selectedWeek, weekOffset)

      let yValue: string | number = '0'
      const foundData = dataTabGraph.find((data: any) => data.week === xValue) // Using type assertion here
      if (foundData) {
        yValue = roundToDecimal(Number(foundData.dataGraph), 2)
      }
      processedData.push({ x: xValue, y: yValue,isMissing: !foundData, })
    })

    return processedData
  }

  useEffect(() => {
    const fetchSelectedWeek = async () => {
      try {
        const response = await axios.get(API_URL + `/global/selected-default-week`)
        setSelectedWeek(response?.data?.week)
      } catch (error) {
        console.error('Error fetching data:', error)
      }
    }
    fetchSelectedWeek()
  }, [])

  useEffect(() => {
    const fetchData = async (week = selectedWeek) => {
      try {
        const response = await axios.get(API_URL + `/trendsPreviousWeek?week=${week}`)


        setDataGraph(response.data)
      } catch (error) {
        console.error('Error fetching data:', error)
        // Handle error or set a default value for data
        setDataGraph(null)
      }
    }
    const fetchAlertData = async (week = selectedWeek) => {
      try {
        const response = await axios.get(API_URL + `/alertsFr?week=${week}`)

        setAlertData(response.data)
      } catch (error) {
        console.error('Error fetching data:', error)
        // Handle error or set a default value for data
        setAlertData(null)
      }
    }
    fetchData(selectedWeek)
    fetchAlertData(selectedWeek)
  }, [selectedWeek])
  function getPreviousWeekOld(currentWeek, numPreviousWeeks) {
    // Parse the input string into a moment object
    const currentDate = moment(currentWeek, 'YYYY-[W]WW')

    // Subtract the specified number of weeks from the current date
    const previousWeek = currentDate.clone().subtract(numPreviousWeeks, 'weeks')

    // Get the year and week number from the moment object
    const prevYear = previousWeek.format('YYYY')
    const prevWeekNum = previousWeek.format('W')

    // Format week number to be 'W1' instead of 'W01' for the first week
    const formattedWeekNum = prevWeekNum.replace(/^0+/, '') // Remove leading zeros

    // Format and return the previous week
    return `${prevYear}-W${formattedWeekNum}`
  }
  function getPreviousWeek(currentWeek: string, numPreviousWeeks: number) {
    // IMPORTANT : utiliser les ISO weeks
    const currentDate = moment(currentWeek, 'GGGG-[W]WW').startOf('isoWeek')

    const previousWeek = currentDate.clone().subtract(numPreviousWeeks, 'weeks')

    const prevYear = previousWeek.format('GGGG')
    const prevWeekNum = previousWeek.format('WW') // toujours 2 digits

    return `${prevYear}-W${parseInt(prevWeekNum, 10)}`
  }
  function viralLoadAlert(alertData) {
    const y =
      ((alertData?.wastewaterViralRatesAlerts[2]?.dataGraph ?? '0') -
        (alertData?.wastewaterViralRatesAlerts[1]?.dataGraph ?? '0')) /
      (alertData?.wastewaterViralRatesAlerts[1]?.dataGraph ?? 1)
    const x =
      ((alertData?.wastewaterViralRatesAlerts[1]?.dataGraph ?? '0') -
        (alertData?.wastewaterViralRatesAlerts[0]?.dataGraph ?? '0')) /
      (alertData?.wastewaterViralRatesAlerts[0]?.dataGraph ?? 1)
    const diff = y - x

    return diff
  }

  // const renderTooltipHospitalAdmission = (props) => (
  //   <Tooltip id='button-tooltip' {...props}>
  //     {getAlertedAgeClasses(alertData?.hospitalAdmissionsRsAlerts)?.map((ageClass, index) => (
  //       <div key={index}>
  //         <i style={{color: '#FF8400'}}>{ageClass}</i>
  //       </div>
  //     ))}
  //   </Tooltip>
  // )
  return (
    <>
      <div className='row p-3 '>
        <FixedNavbar />
        {showScrollNavbar ? <ScrollNavbar /> : null}
        <Card className=' mt-20  mb-6 '>
          <Card.Body className='row justify-content-center pb-0'>
            <Card.Title className='mx-10'>
              <WeekSelect />

              <h1 className='mt-5'>
                Situation of acute respiratory infections in France – 2025-2026
              </h1>
              {/* <div className='d-flex mt-5 justify-content-start my-4'>
                <div>
                  <MenuItemSite title={'FRANCE'} to={'/fr'} />
                </div>
                <div>
                  <MenuItemSite title={'GERMANY'} to={'/ge'} />
                </div>
              </div> */}
            </Card.Title>
            {/* <MySlider /> */}
            <div className='d-flex w-100 justify-content-center'>
              <div
                className=' align-self-center justify-content-center align-items-center
              overflow-x-scroll overflow-y-hidden ' // style={{whiteSpace: 'nowrap'}}
              >
                <div className=' ' style={{ width: '1450px' }}>
                  <Col
                    xs={12}
                    style={{ maxWidth: '1450px' }}
                    className='row  justify-content-center p-0 mt-6 mb-7 grid gap-2'
                  >
                    <Card style={{ width: '10%' }} className='bg-primary   bg-opacity-10 col-md-1'>
                      <Card.Body className='row p-2 justify-content-center'>
                        <Card.Title className='text-center pt-5'>Social media</Card.Title>
                        <Card
                          className={clsx(
                            hoveredCard === '1'
                              ? 'menu-item  p-3 text-center menu-link bg-info border-start-0 border-end-0 bg-opacity-10 border border-primary border-4 rounded active'
                              : 'menu-item  p-3 text-center  menu-link  ',
                            {
                              'bg-primary border-start-0 border-end-0 bg-opacity-10 border border-primary border-4 rounded active':
                                checkIsActive(pathname, 'respiratory-sydroms-in-social-media'),
                            }
                          )}
                          onMouseEnter={() => handleMouseEnter('1')}
                          onMouseLeave={handleMouseLeave}
                          onClick={() => navigate('respiratory-sydroms-in-social-media')}
                        >
                          <Card.Body
                            style={{ maxHeight: '225px' }}
                            className='row  p-0  justify-content-center '
                          >
                            <Card.Subtitle className=''>
                              <div>
                                <p>Respiratory Syndromes in social media</p>
                              </div>

                              {/* {alertData?.numberUsersRsAlerts[0]?.weeklyAnomalyScore &&
                                alertData?.numberUsersRsAlerts[0]?.fifthPercentileThreshold &&
                                alertData.numberUsersRsAlerts[0].weeklyAnomalyScore >
                                alertData.numberUsersRsAlerts[0].fifthPercentileThreshold ? (
                                <i style={{ color: 'red' }} className='fa-solid fa-bell'></i>
                              ) : (
                                alertData?.numberUsersRsAlerts[0]?.weeklyAnomalyScore &&
                                alertData?.numberUsersRsAlerts[0]?.tenthPercentileThreshold &&
                                alertData.numberUsersRsAlerts[0].weeklyAnomalyScore >
                                alertData.numberUsersRsAlerts[0].tenthPercentileThreshold && (
                                  <i style={{ color: '#FF8400' }} className='fa-solid fa-bell'></i>
                                )
                              )} */}
                            </Card.Subtitle>
                            <Col>
                              <div className='pt-5'>
                                <MyLineChart2
                                  data={
                                    dataGraph
                                      ? [
                                        {
                                          id: 'numberUsersRsAlerts',
                                          data: processData(
                                            dataGraph.numberUsersRsAlerts,
                                            selectedWeek
                                          ),
                                        },
                                      ]
                                      : []
                                  }
                                />
                              </div>
                            </Col>
                          </Card.Body>
                        </Card>
                      </Card.Body>
                    </Card>
                    <Card style={{ width: '10%' }} className='bg-primary  bg-opacity-10 col-md-1'>
                      <Card.Body className='row  p-2  justify-content-center card-body-full'>
                        <Card.Title className='text-center mt-2'>Ambulatory care</Card.Title>
                        <Card
                          className={clsx(
                            hoveredCard === '2'
                              ? 'menu-item   p-3 text-center menu-link bg-info border-start-0 border-end-0 bg-opacity-10 border border-primary border-4 rounded active'
                              : 'menu-item  p-3  text-center  menu-link',
                            {
                              'bg-primary border-start-0 border-end-0 bg-opacity-10 border border-primary border-4 rounded active':
                                checkIsActive(pathname, 'ambulatory-care_doctor-visits'),
                            }
                          )}
                          onMouseEnter={() => handleMouseEnter('2')}
                          onMouseLeave={handleMouseLeave}
                          onClick={() => navigate('ambulatory-care_doctor-visits')}
                        >
                          <Card.Body className='row  p-0  justify-content-center'>
                            <Card.Subtitle className='p-0 mb-4  '>
                              <div style={{ paddingBottom: '4%' }}>
                                SOS Médecins visits for Respiratory Syndromes 
                              </div>
                              {/* {alertData?.doctorsVisitsRsAlerts[0]?.alertVirus &&
                                alertData?.doctorsVisitsRsAlerts[0]?.alertVirus === 1 ? (
                                <OverlayTrigger
                                  placement='right'
                                  delay={{ show: 250, hide: 400 }}
                                  overlay={
                                    <Tooltip id='button-tooltip-2'>
                                      <i style={{ color: 'red' }}>All age groups</i>
                                    </Tooltip>
                                  }
                                >
                                  <i style={{ color: 'red' }} className='fa-solid fa-bell'></i>
                                </OverlayTrigger>
                              ) : (
                                <div className='row'>
                                  <i className='fa-solid fa-bell opacity-0'></i>
                                </div>
                              )} */}
                            </Card.Subtitle>
                            <Col className='pt-1'>
                              <MyLineChart2
                                data={
                                  dataGraph
                                    ? [
                                      {
                                        id: 'doctorsVisitsRsAlerts',
                                        data: processData(
                                          dataGraph.doctorsVisitsRsAlerts,
                                          selectedWeek
                                        ),
                                      },
                                    ]
                                    : []
                                }
                              />
                            </Col>
                          </Card.Body>
                        </Card>
                      </Card.Body>
                    </Card>

                    <Card style={{ width: '38%' }} className='bg-primary  bg-opacity-10 col-md-4'>
                      {/* <Card.Title
                  style={{width: '104%', marginLeft: '-2%'}}
                  className='text-center text-white bg-primary rounded p-4'
                >
                  Hospital
                </Card.Title> */}
                      <Card.Title
                        className='text-center'
                        style={{ marginTop: '20px', marginBottom: '14px' }}
                      >
                        Hospital
                      </Card.Title>
                      <Card.Body className='row  p-2  justify-content-center gap-2 card-body-full'>
                        <Card
                          style={{ width: '24%' }}
                          className={clsx(
                            hoveredCard === '3'
                              ? 'menu-item col-md-2 p-3 text-center menu-link bg-info border-start-0 border-end-0 bg-opacity-10 border border-primary border-4 rounded active'
                              : 'menu-item col-md-2 p-3   text-center   menu-link',
                            {
                              'col-md-3 bg-primary border-start-0 border-end-0 bg-opacity-10 border border-primary border-4 rounded active':
                                checkIsActive(pathname, 'hospital-emergency-room-visits'),
                            }
                          )}
                          onMouseEnter={() => handleMouseEnter('3')}
                          onMouseLeave={handleMouseLeave}
                          onClick={() => navigate('hospital-emergency-room-visits')}
                        >
                          <Card.Body className='row  p-0  justify-content-center' style={{ height: '100%' }}>
                            <Card.Subtitle style={{ width: '100%' }} className='pt-1'>
                              <div style={{ paddingBottom: '1%' }}>
                                Emergency room visits for Respiratory Syndromes
                              </div>
                              {/* <div className='row'>
                                <i className='fa-solid fa-bell opacity-0'></i>
                              </div> */}
                              {/* {alertData?.emergencyRoomVisitsRsAlerts &&
                              getAlertedAgeClasses(alertData.emergencyRoomVisitsRsAlerts)
                                ?.length ? (
                                alertData?.emergencyRoomVisitsRsAlerts &&
                                (getAlertedAgeClasses(alertData.emergencyRoomVisitsRsAlerts)?.includes('0-200')) ? (
                                  <OverlayTrigger
                                    placement='right'
                                    delay={{show: 250, hide: 400}}
                                    overlay={
                                      <Tooltip id='button-tooltip-2'>
                                        <i style={{color: 'red'}}>All age groups</i>
                                      </Tooltip>
                                    }
                                  >
                                    <i style={{color: 'red'}} className='fa-solid fa-bell'></i>
                                  </OverlayTrigger>
                                ) : (
                                  <div>
                                    <OverlayTrigger
                                      placement='right'
                                      delay={{show: 250, hide: 400}}
                                      overlay={
                                        <Tooltip id='button-tooltip-2'>
                                          {getAlertedAgeClasses(
                                            alertData.emergencyRoomVisitsRsAlerts
                                          )?.map((ageClass, index) => {
                                            let readableAge
                                            switch (ageClass) {
                                              case 'Less than 1 year':
                                                readableAge = '(< 1 years)'
                                                break
                                              case '[1 - 5[ year(s)':
                                                readableAge = '(1-4 years)'
                                                break
                                              case '[5 - 20[ years':
                                                readableAge = '(5-19 years)'
                                                break
                                              case '[20 - 50[ years':
                                                readableAge = '(20-49 years)'
                                                break
                                              case '[50 - 65[ years':
                                                readableAge = '(50-64 year)'
                                                break
                                              case '65 years and older':
                                                readableAge = '(> 65 years)'
                                                break
                                              case '0-200':
                                                readableAge = 'All ages'
                                                break
                                              default:
                                                readableAge = 'Unknown'
                                                break
                                            }
                                            return (
                                              <div key={index}>
                                                <i style={{color: '#FF8400'}}>{readableAge}</i>
                                              </div>
                                            )
                                          })}
                                        </Tooltip>
                                      }
                                    >
                                      <i
                                        style={{color: '#FF8400'}}
                                        className='col-1 fa-solid fa-bell'
                                      ></i>
                                    </OverlayTrigger>
                                  </div>
                                )
                              ) : (
                                <div className='row'>
                                  <i className='fa-solid fa-bell opacity-0'></i>
                                </div>
                              )} */}
                            </Card.Subtitle>

                            <Col>
                              <MyLineChart2
                                data={
                                  dataGraph
                                    ? [
                                      {
                                        id: 'emergencyRoomVisitsRsAlerts',
                                        data: processData(
                                          dataGraph.emergencyRoomVisitsRsAlerts,
                                          selectedWeek
                                        ),
                                      },
                                    ]
                                    : []
                                }
                              />
                            </Col>
                          </Card.Body>
                        </Card>
                        <Card
                          style={{ width: '24%' }}
                          className={clsx(
                            hoveredCard === '4'
                              ? 'menu-item col-md-2 p-3  text-center menu-link bg-info border-start-0 border-end-0 bg-opacity-10 border border-primary border-4 rounded active'
                              : 'menu-item col-md-2 p-3  text-center  menu-link',
                            {
                              'col-md-3 bg-primary border-start-0 border-end-0 bg-opacity-10 border border-primary border-4 rounded active':
                                checkIsActive(pathname, 'hospital-adminssions'),
                            }
                          )}
                          onMouseEnter={() => handleMouseEnter('4')}
                          onMouseLeave={handleMouseLeave}
                          onClick={() => navigate('hospital-adminssions')}
                        >
                          <Card.Body className='row  p-0  justify-content-center' style={{ height: '100%' }}>
                            <Card.Subtitle className='pt-1'>
                              <div style={{ paddingBottom: '1.5%' }}>
                                Hospital admissions for Respiratory Syndromes
                              </div>
                              <div>
                              </div>
                              {/* {alertData?.hospitalAdmissionsRsAlerts &&
                                getAlertedAgeClasses(alertData.hospitalAdmissionsRsAlerts)?.length ? (
                                alertData?.hospitalAdmissionsRsAlerts &&
                                  getAlertedAgeClasses(
                                    alertData.hospitalAdmissionsRsAlerts
                                  )?.includes('0-200') ? (
                                  <OverlayTrigger
                                    placement='right'
                                    delay={{ show: 250, hide: 400 }}
                                    overlay={
                                      <Tooltip id='button-tooltip-2'>
                                        <i style={{ color: 'red' }}>All age groups</i>
                                      </Tooltip>
                                    }
                                  >
                                    <i style={{ color: 'red' }} className='fa-solid fa-bell'></i>
                                  </OverlayTrigger>
                                ) : (
                                  <div>
                                    <OverlayTrigger
                                      placement='right'
                                      delay={{ show: 250, hide: 400 }}
                                      overlay={
                                        <Tooltip id='button-tooltip-2'>
                                          {getAlertedAgeClasses(
                                            alertData.hospitalAdmissionsRsAlerts
                                          )?.map((ageClass, index) => {
                                            let readableAge
                                            switch (ageClass) {
                                              case 'Less than 1 year':
                                                readableAge = '(< 1 years)'
                                                break
                                              case '[1 - 5[ year(s)':
                                                readableAge = '(1-4 years)'
                                                break
                                              case '[5 - 20[ years':
                                                readableAge = '(5-19 years)'
                                                break
                                              case '[20 - 50[ years':
                                                readableAge = '(20-49 years)'
                                                break
                                              case '[50 - 65[ years':
                                                readableAge = '(50-64 year)'
                                                break
                                              case '65 years and older':
                                                readableAge = '(> 65 years)'
                                                break
                                              default:
                                                readableAge = 'Unknown'
                                                break
                                            }
                                            return (
                                              <div key={index}>
                                                <i style={{ color: '#FF8400' }}>{readableAge}</i>
                                              </div>
                                            )
                                          })}
                                        </Tooltip>
                                      }
                                    >
                                      <i
                                        style={{ color: '#FF8400' }}
                                        className='col-1 fa-solid fa-bell'
                                      ></i>
                                    </OverlayTrigger>
                                  </div>
                                )
                              ) : (
                                <div className='row'>
                                  <i className='fa-solid fa-bell opacity-0'></i>
                                </div>
                              )} */}
                            </Card.Subtitle>
                            <Col>
                              <MyLineChart2
                                data={
                                  dataGraph
                                    ? [
                                      {
                                        id: 'hospitalAdmissionsRsAlerts',
                                        data: processData(
                                          dataGraph.hospitalAdmissionsRsAlerts,
                                          selectedWeek
                                        ),
                                      },
                                    ]
                                    : []
                                }
                              />
                            </Col>
                          </Card.Body>
                        </Card>
                        <Card
                          style={{ width: '24%' }}
                          className={clsx(
                            hoveredCard === '5'
                              ? 'menu-item col-md-2 p-3  text-center menu-link bg-info border-start-0 border-end-0 bg-opacity-10 border border-primary border-4 rounded active'
                              : 'menu-item col-md-2 p-3  text-center  menu-link',
                            {
                              'col-md-3 bg-primary border-start-0 border-end-0 bg-opacity-10 border border-primary border-4 rounded active':
                                checkIsActive(pathname, 'icu-adminssions'),
                            }
                          )}
                          onMouseEnter={() => handleMouseEnter('5')}
                          onMouseLeave={handleMouseLeave}
                          onClick={() => navigate('icu-adminssions')}
                        >
                          <Card.Body className='row  p-0  justify-content-center' style={{ height: '100%' }}>
                            <Card.Subtitle className='pb-6 '>
                              <div style={{ paddingBottom: '1.5%' }}>
                                ICU admissions for Respiratory Syndromes
                              </div>
                              {/* <div>
                                {alertData?.icuAdmissionsRsDiagnosisAlerts[0]?.alertVirus &&
                                alertData?.icuAdmissionsRsDiagnosisAlerts[0]?.alertVirus === 1 ? (
                                  <OverlayTrigger
                                    placement='right'
                                    delay={{show: 250, hide: 400}}
                                    overlay={
                                      <Tooltip id='button-tooltip-2'>
                                        <i style={{color: 'red'}}>All age groups</i>
                                      </Tooltip>
                                    }
                                  >
                                    <i style={{color: 'red'}} className='fa-solid fa-bell'></i>
                                  </OverlayTrigger>
                                ) : (
                                  <div className='row'>
                                    <i className='fa-solid fa-bell opacity-0'></i>
                                  </div>
                                )}
                              </div> */}
                              <div>
                                {/* {alertData?.icuAdmissionsRsDiagnosisAlerts &&
                                  getAlertVirus(alertData.icuAdmissionsRsDiagnosisAlerts)?.length ? (
                                  alertData?.hospitalAdmissionsRsAlerts &&
                                    getAlertVirus(alertData.icuAdmissionsRsDiagnosisAlerts)
                                      ?.length! >= 1 ? (
                                    <OverlayTrigger
                                      placement='right'
                                      delay={{ show: 250, hide: 400 }}
                                      overlay={
                                        <Tooltip id='button-tooltip-2'>
                                          <i style={{ color: 'red' }}>All age groups</i>
                                        </Tooltip>
                                      }
                                    >
                                      <i style={{ color: 'red' }} className='fa-solid fa-bell'></i>
                                    </OverlayTrigger>
                                  ) : (
                                    <div className='row'>
                                      <i className='fa-solid fa-bell opacity-0'></i>
                                    </div>
                                  )
                                ) : (
                                  <div className='row'>
                                    <i className='fa-solid fa-bell opacity-0'></i>
                                  </div>
                                )} */}
                              </div>
                            </Card.Subtitle>
                            <Col>
                              <MyLineChart2
                                data={
                                  dataGraph
                                    ? [
                                      {
                                        id: 'icuAdmissionsRsDiagnosisAlerts',
                                        data: processData(
                                          dataGraph.icuAdmissionsRsDiagnosisAlerts,
                                          selectedWeek
                                        ),
                                      },
                                    ]
                                    : []
                                }
                              />
                            </Col>
                          </Card.Body>
                        </Card>
                        <Card
                          style={{ width: '24%' }}
                          className={clsx(
                            hoveredCard === '6'
                              ? 'menu-item col-md-2  p-3 text-center menu-link bg-info border-start-0 border-end-0 bg-opacity-10 border border-primary border-4 rounded active'
                              : 'menu-item col-md-2  p-3 text-center  menu-link',
                            {
                              'col-md-3 bg-primary border-start-0 border-end-0 bg-opacity-10 border border-primary border-4 rounded active':
                                checkIsActive(pathname, 'hospital-deaths-for-respiratory-synd'),
                            }
                          )}
                          onMouseEnter={() => handleMouseEnter('6')}
                          onMouseLeave={handleMouseLeave}
                          onClick={() => navigate('hospital-deaths-for-respiratory-synd')}
                        >
                          <Card.Body className='row  p-0  justify-content-center' style={{ height: '100%' }}>
                            <Card.Subtitle className='pb-6 '>
                              <div style={{ paddingBottom: '1.5%' }}>
                                Deaths for Respiratory Syndromes
                              </div>
                              <div>
                                {/* {alertData?.rsDiagnosisDeathsAlerts[0]?.alertVirus &&
                                alertData?.rsDiagnosisDeathsAlerts[0]?.alertVirus === 1 ? (
                                  <OverlayTrigger
                                    placement='right'
                                    delay={{show: 250, hide: 400}}
                                    overlay={
                                      <Tooltip id='button-tooltip-2'>
                                        <i style={{color: 'red'}}>All age groups</i>
                                      </Tooltip>
                                    }
                                  >
                                    <i style={{color: 'red'}} className='fa-solid fa-bell'></i>
                                  </OverlayTrigger>
                                ) : (
                                  <div className='row'>
                                    <i className='fa-solid fa-bell opacity-0'></i>
                                  </div>
                                )} */}
                                {/* {alertData?.rsDiagnosisDeathsAlerts &&
                                  getAlertVirus(alertData.rsDiagnosisDeathsAlerts)?.length ? (
                                  alertData?.rsDiagnosisDeathsAlerts &&
                                    getAlertVirus(alertData.rsDiagnosisDeathsAlerts)?.length! >= 1 ? (
                                    <OverlayTrigger
                                      placement='right'
                                      delay={{ show: 250, hide: 400 }}
                                      overlay={
                                        <Tooltip id='button-tooltip-2'>
                                          <i style={{ color: 'red' }}>All age groups</i>
                                        </Tooltip>
                                      }
                                    >
                                      <i style={{ color: 'red' }} className='fa-solid fa-bell'></i>
                                    </OverlayTrigger>
                                  ) : (
                                    <div className='row'>
                                      <i className='fa-solid fa-bell opacity-0'></i>
                                    </div>
                                  )
                                ) : (
                                  <div className='row'>
                                    <i className='fa-solid fa-bell opacity-0'></i>
                                  </div>
                                )} */}
                              </div>
                            </Card.Subtitle>
                            <Col>
                              <MyLineChart2
                                data={
                                  dataGraph
                                    ? [
                                      {
                                        id: 'rsDiagnosisDeathsAlerts',
                                        data: processData(
                                          dataGraph.rsDiagnosisDeathsAlerts,
                                          selectedWeek
                                        ),
                                      },
                                    ]
                                    : []
                                }
                              />
                            </Col>
                          </Card.Body>
                        </Card>
                      </Card.Body>
                    </Card>
                    <Card style={{ width: '39%' }} className='bg-primary  bg-opacity-10  col-md-4 '>
                      <Card.Title
                        style={{
                          width: '104%',
                          marginLeft: '-2%',
                          marginTop: '9px',
                          marginBottom: '-0.1%',
                        }}
                        className='text-center  bg-primary rounded bg-opacity-0 p-4'
                      >
                        Virology
                      </Card.Title>
                      {/* <Card.Title
                  style={{width: '104%', marginLeft: '-2%'}}
                  className='text-center text-white  bg-primary rounded  p-4'
                >
                  Virology
                </Card.Title> */}
                      <Card.Body className='row  p-2  justify-content-center gap-2' style={{ height: '100%' }}>
                        <Card
                          style={{ width: '24%' }}
                          className={clsx(
                            hoveredCard === '7'
                              ? 'menu-item col-md-3  p-3  text-center menu-link bg-info border-start-0 border-end-0 bg-opacity-10 border border-primary border-4 rounded active'
                              : 'menu-item col-md-3  p-3  text-center  menu-link',
                            {
                              'col-md-3 bg-primary border-start-0 border-end-0 bg-opacity-10 border border-primary border-4 rounded active':
                                checkIsActive(pathname, 'virology-influenza'),
                            }
                          )}
                          onMouseEnter={() => handleMouseEnter('7')}
                          onMouseLeave={handleMouseLeave}
                          onClick={() => navigate('virology-influenza')}
                        >
                          <Card.Body className='row  p-0  justify-content-center card-body-full'>
                            <Card.Subtitle className='mb-11 '>
                              {/* <div style={{ paddingBottom: '8%' }}> */}
                              Influenza positivity rate
                              {/* </div> */}
                              {/* {alertData?.influenzaPositivityRatesAlerts &&
                                getAlertedAgeClasses(alertData.influenzaPositivityRatesAlerts)
                                  ?.length ? (
                                alertData?.influenzaPositivityRatesAlerts &&
                                  getAlertedAgeClasses(alertData.influenzaPositivityRatesAlerts)
                                    ?.length! > 6 ? (
                                  <OverlayTrigger
                                    placement='right'
                                    delay={{ show: 250, hide: 400 }}
                                    overlay={
                                      <Tooltip id='button-tooltip-2'>
                                        <i style={{ color: 'red' }}>All age groups</i>
                                      </Tooltip>
                                    }
                                  >
                                    <i style={{ color: 'red' }} className='fa-solid fa-bell'></i>
                                  </OverlayTrigger>
                                ) : (
                                  <div>
                                    <OverlayTrigger
                                      placement='right'
                                      delay={{ show: 250, hide: 400 }}
                                      overlay={
                                        <Tooltip id='button-tooltip-2'>
                                          {getAlertedAgeClasses(
                                            alertData.influenzaPositivityRatesAlerts
                                          )?.map((ageClass, index) => {
                                            let readableAge
                                            switch (ageClass) {
                                              case '< 1 year':
                                                readableAge = '(< 1 years)'
                                                break
                                              case '1 to 5':
                                                readableAge = '(1-5 years)'
                                                break
                                              case '6 to 11':
                                                readableAge = '(6-11 years)'
                                                break
                                              case '11 to 18':
                                                readableAge = '(11-18 years)'
                                                break
                                              case '18 to 40':
                                                readableAge = '(18-40 year)'
                                                break
                                              case '40 to 65':
                                                readableAge = '(40-65 year)'
                                                break
                                              case '> 65 years':
                                                readableAge = '(> 65 years)'
                                                break
                                              default:
                                                readableAge = 'Unknown'
                                                break
                                            }
                                            return (
                                              <div key={index}>
                                                <i style={{ color: '#FF8400' }}>{readableAge}</i>
                                              </div>
                                            )
                                          })}
                                        </Tooltip>
                                      }
                                    >
                                      <i
                                        style={{ color: '#FF8400' }}
                                        className='col-1 fa-solid fa-bell'
                                      ></i>
                                    </OverlayTrigger>
                                  </div>
                                )
                              ) : (
                                <div className='row'>
                                  <i className='fa-solid fa-bell opacity-0'></i>
                                </div>
                              )} */}
                            </Card.Subtitle>
                            <Col>
                              <MyLineChart2
                                data={
                                  dataGraph
                                    ? [
                                      {
                                        id: 'influenzaPositivityRatesAlerts',
                                        data: processData(
                                          dataGraph.influenzaPositivityRatesAlerts,
                                          selectedWeek
                                        ),
                                      },
                                    ]
                                    : []
                                }
                                percent={true}
                              />
                            </Col>
                          </Card.Body>
                        </Card>
                        <Card
                          style={{ width: '24%' }}
                          className={clsx(
                            hoveredCard === '8'
                              ? 'menu-item col-md-3 p-3  text-center menu-link bg-info border-start-0 border-end-0 bg-opacity-10 border border-primary border-4 rounded active'
                              : 'menu-item col-md-3 p-3  text-center  menu-link',
                            {
                              'col-md-3 bg-primary border-start-0 border-end-0 bg-opacity-10 border border-primary border-4 rounded active':
                                checkIsActive(pathname, 'virology-covid'),
                            }
                          )}
                          onMouseEnter={() => handleMouseEnter('8')}
                          onMouseLeave={handleMouseLeave}
                          onClick={() => navigate('virology-covid')}
                        >
                          <Card.Body className='row  p-0  justify-content-center card-body-full'>
                            <Card.Subtitle className='mb-6 '>
                              Covid-19 positivity rate and variants
                              {/* {alertData?.covid19PositivityRatesAlerts &&
                                getAlertedAgeClasses(alertData.covid19PositivityRatesAlerts)
                                  ?.length ? (
                                alertData?.covid19PositivityRatesAlerts &&
                                  getAlertedAgeClasses(alertData.covid19PositivityRatesAlerts)
                                    ?.length! > 6 ? (
                                  <OverlayTrigger
                                    placement='right'
                                    delay={{ show: 250, hide: 400 }}
                                    overlay={
                                      <Tooltip id='button-tooltip-2'>
                                        <i style={{ color: 'red' }}>All age groups</i>
                                      </Tooltip>
                                    }
                                  >
                                    <i style={{ color: 'red' }} className='fa-solid fa-bell'></i>
                                  </OverlayTrigger>
                                ) : (
                                  // <div>
                                  //   <i style={{color: '#FF8400'}} className='col-1 fa-solid fa-bell'></i>
                                  //   {getAlertedAgeClasses(alertData.covid19PositivityRatesAlerts)?.map(
                                  //     (ageClass, index) => (
                                  //       <div key={index}>
                                  //         <i style={{color: '#FF8400'}}>{ageClass}</i>
                                  //       </div>
                                  //     )
                                  //   )}
                                  // </div>
                                  <div>
                                    <OverlayTrigger
                                      placement='right'
                                      delay={{ show: 250, hide: 400 }}
                                      overlay={
                                        <Tooltip id='button-tooltip-2'>
                                          {getAlertedAgeClasses(
                                            alertData.covid19PositivityRatesAlerts
                                          )?.map((ageClass, index) => {
                                            let readableAge
                                            switch (ageClass) {
                                              case '< 1 year':
                                                readableAge = '(< 1 years)'
                                                break
                                              case '1 to 5':
                                                readableAge = '(1-5 years)'
                                                break
                                              case '6 to 11':
                                                readableAge = '(6-11 years)'
                                                break
                                              case '11 to 18':
                                                readableAge = '(11-18 years)'
                                                break
                                              case '18 to 40':
                                                readableAge = '(18-40 year)'
                                                break
                                              case '40 to 65':
                                                readableAge = '(40-65 year)'
                                                break
                                              case '> 65 years':
                                                readableAge = '(> 65 years)'
                                                break
                                              default:
                                                readableAge = 'Unknown'
                                                break
                                            }
                                            return (
                                              <div key={index}>
                                                <i style={{ color: '#FF8400' }}>{readableAge}</i>
                                              </div>
                                            )
                                          })}
                                        </Tooltip>
                                      }
                                    >
                                      <i
                                        style={{ color: '#FF8400' }}
                                        className='col-1 fa-solid fa-bell'
                                      ></i>
                                    </OverlayTrigger>
                                  </div>
                                )
                              ) : (
                                <div className='row'>
                                  <i className='fa-solid fa-bell opacity-0'></i>
                                </div>
                              )} */}
                            </Card.Subtitle>
                            <Col>
                              <MyLineChart2
                                data={
                                  dataGraph
                                    ? [
                                      {
                                        id: 'covid19PositivityRatesAlerts',
                                        data: processData(
                                          dataGraph.covid19PositivityRatesAlerts,
                                          selectedWeek
                                        ),
                                      },
                                    ]
                                    : []
                                }
                                percent={true}
                              />
                            </Col>
                          </Card.Body>
                        </Card>
                        <Card
                          style={{ width: '24%' }}
                          className={clsx(
                            hoveredCard === '9'
                              ? 'menu-item col-md-3  p-3 text-center menu-link bg-info border-start-0 border-end-0 bg-opacity-10 border border-primary border-4 rounded active'
                              : 'menu-item col-md-3  p-3 text-center  menu-link',
                            {
                              'col-md-3 bg-primary border-start-0  border-end-0 bg-opacity-10 border border-primary border-4 rounded active':
                                checkIsActive(pathname, 'virology-rsv'),
                            }
                          )}
                          onMouseEnter={() => handleMouseEnter('9')}
                          onMouseLeave={handleMouseLeave}
                          onClick={() => navigate('virology-rsv')}
                        >
                          <Card.Body className='row  p-0  justify-content-center card-body-full'>
                            <Card.Subtitle className=' mb-11 '>
                              RSV positivity rate
                              <br />
                              {/* {alertData?.rsvPositivityRatesAlerts &&
                                getAlertedAgeClasses(alertData.rsvPositivityRatesAlerts)?.length ? (
                                alertData?.rsvPositivityRatesAlerts &&
                                  getAlertedAgeClasses(alertData.rsvPositivityRatesAlerts)?.length! >
                                  6 ? (
                                  <OverlayTrigger
                                    placement='right'
                                    delay={{ show: 250, hide: 400 }}
                                    overlay={
                                      <Tooltip id='button-tooltip-2'>
                                        <i style={{ color: 'red' }}>All age groups</i>
                                      </Tooltip>
                                    }
                                  >
                                    <i style={{ color: 'red' }} className='fa-solid fa-bell'></i>
                                  </OverlayTrigger>
                                ) : (
                                  // <div>
                                  //   <i style={{color: '#FF8400'}} className='col-1 fa-solid fa-bell'></i>
                                  //   {getAlertedAgeClasses(alertData.rsvPositivityRatesAlerts)?.map(
                                  //     (ageClass, index) => (
                                  //       <div key={index}>
                                  //         <i style={{color: '#FF8400'}}>{ageClass}</i>
                                  //       </div>
                                  //     )
                                  //   )}
                                  // </div>
                                  <div>
                                    <OverlayTrigger
                                      placement='right'
                                      delay={{ show: 250, hide: 400 }}
                                      overlay={
                                        <Tooltip id='button-tooltip-2'>
                                          {getAlertedAgeClasses(
                                            alertData.rsvPositivityRatesAlerts
                                          )?.map((ageClass, index) => {
                                            let readableAge
                                            switch (ageClass) {
                                              case '< 1 year':
                                                readableAge = '(< 1 years)'
                                                break
                                              case '1 to 5':
                                                readableAge = '(1-5 years)'
                                                break
                                              case '6 to 11':
                                                readableAge = '(6-11 years)'
                                                break
                                              case '11 to 18':
                                                readableAge = '(11-18 years)'
                                                break
                                              case '18 to 40':
                                                readableAge = '(18-40 year)'
                                                break
                                              case '40 to 65':
                                                readableAge = '(40-65 year)'
                                                break
                                              case '> 65 years':
                                                readableAge = '(> 65 years)'
                                                break
                                              default:
                                                readableAge = 'Unknown'
                                                break
                                            }
                                            return (
                                              <div key={index}>
                                                <i style={{ color: '#FF8400' }}>{readableAge}</i>
                                              </div>
                                            )
                                          })}
                                        </Tooltip>
                                      }
                                    >
                                      <i
                                        style={{ color: '#FF8400' }}
                                        className='col-1 fa-solid fa-bell'
                                      ></i>
                                    </OverlayTrigger>
                                  </div>
                                )
                              ) : (
                                <div className='row'>
                                  <i className='fa-solid fa-bell opacity-0'></i>
                                </div>
                              )} */}
                            </Card.Subtitle>
                            <Col>
                              <MyLineChart2
                                data={
                                  dataGraph
                                    ? [
                                      {
                                        id: 'rsvPositivityRatesAlerts',
                                        data: processData(
                                          dataGraph.rsvPositivityRatesAlerts,
                                          selectedWeek
                                        ),
                                      },
                                    ]
                                    : []
                                }
                                percent={true}
                              />
                            </Col>
                          </Card.Body>
                        </Card>
                        <Card
                          style={{ width: '24%' }}
                          className={clsx(
                            hoveredCard === '10'
                              ? 'menu-item col-md-3 p-3 text-center menu-link bg-info border-start-0 border-end-0 bg-opacity-10 border border-primary border-4 rounded active'
                              : 'menu-item col-md-3 p-3  text-center  menu-link',
                            {
                              'col-md-3 bg-primary  border-start-0 border-end-0 bg-opacity-10 border border-primary border-4 rounded active':
                                checkIsActive(pathname, 'virology-waste-water'),
                            }
                          )}
                          onMouseEnter={() => handleMouseEnter('10')}
                          onMouseLeave={handleMouseLeave}
                          onClick={() => navigate('virology-waste-water')}
                        >
                          <Card.Body className='row  p-0  justify-content-center card-body-full'>
                            <Card.Subtitle className=' mb-6'>
                              Viral Load in wastewater - Covid-19
                              {/* {viralLoadAlert(alertData) >= 20 ? (
                                <div>
                                  <OverlayTrigger
                                    placement='right'
                                    delay={{ show: 250, hide: 400 }}
                                    overlay={
                                      <Tooltip id='button-tooltip-2'>
                                        <i style={{ color: 'red' }}>All age groups</i>
                                      </Tooltip>
                                    }
                                  >
                                    <i style={{ color: 'red' }} className='fa-solid fa-bell'></i>
                                  </OverlayTrigger>
                                </div>
                              ) : viralLoadAlert(alertData) >= 10 ? (
                                <div>
                                  <i
                                    style={{ color: 'orange' }}
                                    className='col-1 fa-solid fa-bell'
                                  ></i>
                                </div>
                              ) : (
                                <>
                                  <div className='row'>
                                    <i className='fa-solid fa-bell opacity-0'></i>
                                  </div>
                                </>
                              )} */}
                            </Card.Subtitle>
                            <Col>
                              <MyLineChart2
                                data={
                                  dataGraph
                                    ? [
                                      {
                                        id: 'wastewaterViralRatesAlerts',
                                        data: processData(
                                          dataGraph.wastewaterViralRatesAlerts,
                                          selectedWeek
                                        ),
                                      },
                                    ]
                                    : []
                                }
                              />
                            </Col>
                          </Card.Body>
                        </Card>
                      </Card.Body>
                    </Card>
                  </Col>
                </div>
              </div>
            </div>

            <div className='row justify-content-center col-12'>
              <p className='text-center' style={{ color: '#FF8400', fontSize: '12px' }}>
                {/* <i style={{ color: '#FF8400' }} className='fa-solid fa-bell'></i>{' '}
                <OverlayTrigger
                  placement='right'
                  overlay={
                    <Tooltip id='logo-tooltip' style={{ width: '300px' }}>
                      <p>
                        An alert appears if the current case count exceeds the upper bound of the
                        corresponding value for each week of the previous year(s) OR if the current
                        case count exceeds the upper bound of the average monthly case counts. An
                        alert does not necessarily reflect the current trend.
                      </p>
                    </Tooltip>
                  }
                >
                  <b>Alert for some age groups</b>
                </OverlayTrigger>
                &nbsp;&nbsp;&nbsp;&nbsp;
                <i style={{ color: 'red' }} className='fa-solid fa-bell'></i>{' '}
                <OverlayTrigger
                  placement='right'
                  overlay={
                    <Tooltip id='logo-tooltip' style={{ width: '300px' }}>
                      <p>
                        An alert appears if the current case count exceeds the upper bound of the
                        corresponding value for each week of the previous year(s) OR if the current
                        case count exceeds the upper bound of the average monthly case counts. An
                        alert does not necessarily reflect the current trend.
                      </p>
                    </Tooltip>
                  }
                >
                  <b style={{ color: 'red' }}>Alert all age groups</b>
                </OverlayTrigger> */}
                &nbsp;&nbsp;&nbsp;&nbsp;
                <i style={{ color: 'black ' }} className='fa-solid fa-circle'></i>{' '}
                <OverlayTrigger
                  placement='right'
                  overlay={
                    <Tooltip id='logo-tooltip' style={{ width: '300px' }}>
                      <p>Data not available for the date considered</p>
                    </Tooltip>
                  }
                >
                  <b style={{ color: 'black' }}>Missing Data</b>
                </OverlayTrigger>
              </p>
              <Card.Title className='mx-8' style={{ marginTop: '-1%' }}>
                <h3 className='mb-5 text-start'>
                  Trends relative to the 2 previous weeks
                </h3>
              </Card.Title>
            </div>
          </Card.Body>
        </Card>
      </div>
    </>
  )
}
